import * as tslib_1 from "tslib";
import './slider.less';
import { CarouselStore } from '../store/carouselstore';
export { Carousel as Slider } from '../ui/carousel';
// Backwards compatibility
var SliderStore = /** @class */ (function (_super) {
    tslib_1.__extends(SliderStore, _super);
    function SliderStore() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.className = 'slider';
        return _this;
        //animating = stream(false)
    }
    SliderStore.prototype.index = function () {
        if (!this.carousel)
            return this.initialPage;
        return this.activePage;
    };
    SliderStore.prototype.total = function () {
        return this.totalPages;
    };
    SliderStore.prototype.actives = function () {
        var _this = this;
        if (!this.carousel)
            return [];
        return this.carousel.snaps.elements.map(function (_, i) { return function () { return _this.isActive(i); }; });
    };
    return SliderStore;
}(CarouselStore));
export { SliderStore };
